module.exports = __webpack_public_path__ + "static/media/dtj-sketch-1.1cb9698b.jpg";